import React from "react"
import classNames from "classnames/bind"

import styles from "./fluid-image.module.scss"

const cx = classNames.bind(styles)

export const FluidImage = ({image, altText}) => {
    return (
        <span className={cx('image-wrapper')}>
            <img src={image} alt={altText} />
        </span>
    )
}